<div class="embed-container embed-placeholder faded" style="background: #EBF3F6; min-height: 300px; text-align: center; display: table; padding: 20px; width: 100%; cursor: default; color: #A9B4B4;">
    <div style="margin-top: 20px; display: table-cell; vertical-align: middle;">
        <mat-icon>code</mat-icon>
        <span style="display: block; text-transform: uppercase;">Embed</span>
        <span style="display: block; text-transform: uppercase;">{{embed}}</span>
    </div>
</div>